import { CodeBook } from "@king-ict/eupisi-ui/models";

import { Answer } from "./Answer";
import { RequestAnswer } from "./RequestAnswer";

export interface Question extends CodeBook {
  questionGroupQuestionId: number;
  sort: number;
  dataTypeId: DataTypeEnum;
  displayTypeId: DisplayTypeEnum;
  isRequired: boolean;
  isVisible: boolean;
  isRepeatable: boolean;
  answerLength?: number;
  answerSource?: string;
  requiredForAnswerId?: number;

  answers?: Answer[];
  requestAnswer?: RequestAnswer;

  parentQuestionGroupQuestionId?: number;
  parentAnswerId?: number;
}

export enum DataTypeEnum {
  Text = 1,
  Date,
  Integer,
  Decimal,
  Time,
  File,
}

export enum DisplayTypeEnum {
  ReadOnly = 1,
  Text = 2,
  Select = 3,
  Radio = 4,
  Date = 5,
  Time = 6,
  Upload = 7,
  MultiSelect = 8,
  TextArea = 9,
}
/*
        public List<QuestionnaireAnswerDto> Answers { get; set; }

        public RequestAnswerDto RequestAnswer { get; set; }

*/
